import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';

export function Logo({ compact = false, className }: { compact?: boolean; className?: string }) {
  const lightAsset = compact
    ? '/favicon-256x256.png'
    : '/brand/nexhance-logo-on-light.png';
  const darkAsset = compact
    ? '/favicon-256x256.png'
    : '/brand/nexhance-logo-on-dark.png';

  return (
    <Link to="/" className={cn('brand', compact && 'brand-compact', className)} aria-label="Nexhance AI home">
      <img className="brand-logo brand-logo-on-light" src={lightAsset} alt="" aria-hidden="true" />
      <img className="brand-logo brand-logo-on-dark" src={darkAsset} alt="" aria-hidden="true" />
    </Link>
  );
}
